// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Types__Time = require("../types/Types__Time.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../../../v5/autocomplete/AutocompleteV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function make(time) {
  return {
          value: time,
          label: Types__Time.to12HourString(time)
        };
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return Types__Time.to24HourString(x.value);
}

var $$Option = {
  make: make,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function makeOptions(startTime, endTime, intervals) {
  var hours = Belt_Array.range(startTime, endTime);
  var minutes = Belt_Array.rangeBy(0, 59, Caml_int32.div(60, intervals));
  return Belt_Array.map(Belt_Array.concatMany(Belt_Array.map(hours, (function (hour) {
                        return Belt_Array.map(minutes, (function (minute) {
                                      return [
                                              hour,
                                              minute
                                            ];
                                    }));
                      }))), (function (param) {
                return make(Types__Time.make(param[0], param[1]));
              }));
}

function TimePicker(props) {
  var onChange = props.onChange;
  var options = makeOptions(props.startTime, props.endTime, props.hourlyIntervals);
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
              getOptionLabel: getOptionLabel,
              getOptionValue: getOptionValue,
              isClearable: props.isClearable,
              onBlur: props.onBlur,
              onChange: (function (v) {
                  onChange(Core__Option.map(v, (function (v) {
                              return v.value;
                            })));
                }),
              onFocus: props.onFocus,
              options: options,
              placeholder: props.placeholder,
              value: Core__Option.map(props.value, make)
            });
}

var make$1 = TimePicker;

exports.$$Option = $$Option;
exports.makeOptions = makeOptions;
exports.make = make$1;
/* Types__Time Not a pure module */
